import { Button, Modal } from "antd";
import { CrownFilled, StarFilled } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export const AlertaVip = ({ VistaGSeguros }) => {
  const { gsegurosEmision } = useSelector((s) => s.polizarioReducer);
  const [tipo, setTipo] = useState(null);

  useEffect(() => {
    if (VistaGSeguros !== 1) return;
    if (gsegurosEmision.cliente_vip == "SI") setTipo("VIP");
    else if (gsegurosEmision.condiciones_especiales == "SI") setTipo("ESPECIAL");
  }, [VistaGSeguros]);

  return (
    <Modal open={!!tipo} footer={null} closable={false} centered width={300}>
      <div style={{ textAlign: "center", padding: "16px 0 8px" }}>
        {tipo === "VIP"
          ? <CrownFilled style={{ fontSize: 32, color: "#faad14" }} />
          : <StarFilled style={{ fontSize: 32, color: "#1677ff" }} />}
        <div style={{ fontSize: 18, fontWeight: 700, margin: "12px 0 16px" }}>
          {tipo === "VIP" ? "Cliente VIP" : "Condiciones Especiales"}
        </div>
        <Button type="primary" block onClick={() => setTipo(null)}>Entendido</Button>
      </div>
    </Modal>
  );
};
